import Loader from "uicomponents/Loader";
import ErrorPage from "uicomponents/Error";
import { getProspectUuid } from "utils/idHelpers";
import ResultsPage from "./Results";
import { useGetCoverageEligibilityQuery } from "types/generated/operations";
import { getAppType } from "utils/helper";

const ResultsPageModel = () => {
  const { data, error, loading } = useGetCoverageEligibilityQuery({
    variables: { uuid: getProspectUuid(), appType: getAppType() },
    fetchPolicy: "no-cache",
  });

  if (loading) {
    return <Loader />;
  }

  if (error) {
    return <ErrorPage />;
  }

  return <ResultsPage data={data?.prospect} />;
};
export default ResultsPageModel;
